
import { Card, CardContent } from "@/components/ui/card";
import { formatDateTime } from "@/utils/dateUtils";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

type ComponentInfoProps = {
  component: {
    name: string;
    component_types?: { name: string };
    created_at: string;
    modified_at: string | null;
    repo_url?: string | null;
    main_url?: string | null;
    logs_url?: string | null;
    dash_url?: string | null;
    swagger_url?: string | null;
  } | null;
};

export const ComponentInfo = ({ component }: ComponentInfoProps) => {
  const handleUrlClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const renderUrlField = (label: string, url: string | null | undefined) => {
    return (
      <div>
        <p className="text-sm text-muted-foreground">{label}:</p>
        <div className="flex items-center gap-2">
          <p className="font-medium text-foreground">{url || "Não informado"}</p>
          {url && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-4 w-4 p-0"
                    onClick={() => handleUrlClick(url)}
                  >
                    <ExternalLink className="h-3 w-3" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Abrir URL</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      </div>
    );
  };

  return (
    <Card className="border border-border/40 shadow-sm">
      <CardContent className="p-6">
        <h3 className="text-xl font-semibold mb-4 text-foreground">Informações do Componente</h3>
        
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <p className="text-sm text-muted-foreground">Nome:</p>
            <p className="font-medium text-foreground">{component?.name}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Tipo:</p>
            <p className="font-medium text-foreground">{component?.component_types?.name}</p>
          </div>
        </div>

        <div className="space-y-4 mb-6">
          {renderUrlField("URL Repositório", component?.repo_url)}
          {renderUrlField("URL Principal", component?.main_url)}
          {renderUrlField("URL Logs", component?.logs_url)}
          {renderUrlField("URL Dashboard", component?.dash_url)}
          {renderUrlField("URL Swagger", component?.swagger_url)}
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-muted-foreground">Criado em:</p>
            <p className="font-medium text-foreground">{formatDateTime(component?.created_at)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Última modificação:</p>
            <p className="font-medium text-foreground">{formatDateTime(component?.modified_at) || "Não disponível"}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
